import { Bonus, SearchBonus } from '../../../../types/bonus';
import { GlobalSearchResult } from '../../api/hooks/search';
import User, { SearchUser } from '../../types/user';

export const selectSearchResult = (data?: GlobalSearchResult) => {
	const bonusCount = data?.bonuses.length || 0;
	const userCount = data?.users.length || 0;
	const recordCount = bonusCount + userCount;

	const hasBonuses = !!bonusCount;
	const hasUsers = !!userCount;
	const hasAllRecords = hasBonuses && hasUsers;
	const hasAnyRecords = hasBonuses || hasUsers;

	return {
		bonusCount,
		hasAllRecords,
		hasAnyRecords,
		hasBonuses,
		hasUsers,
		recordCount,
		userCount,
	};
};

export const toBonusType = (bonus: SearchBonus): Bonus =>
	({
		...bonus,
		id: bonus.objectID,
	}) as unknown as Bonus;

export const toUserType = (user: SearchUser): User =>
	({
		...user,
		id: user.objectID,
		profile_pic_url: user.profile_pic,
		username: user.slug,
	}) as unknown as User;
